// frontend/src/features/content/EditContent.js
import { useParams } from 'react-router-dom';
import EditContentForm from './EditContentForm'; // ✅ हम इसे आगे बनाएंगे
import { useGetAllContentAdminQuery, selectContentByIdForAdmin } from './contentApiSlice'; // ✅ Content API slices से इम्पोर्ट
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import { Spinner, Alert, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const EditContent = () => {
    useTitle('Nirakar Satguru: Edit Content');

    const { id: contentId } = useParams(); // URL से कंटेंट ID प्राप्त करें
    const { isManager, isAdmin } = useAuth(); // रोल जांचें

    // Redux store से pagination/filter states प्राप्त करें
    const { pageNumber = 1, searchQuery = '', isActiveFilter = '', categoryFilter = '' } = useSelector((state) => state.content);
    const queryArgs = { page: pageNumber, search: searchQuery, isActive: isActiveFilter, category: categoryFilter };

    // useGetAllContentAdminQuery का उपयोग करें ताकि डेटा कैश में उपलब्ध हो
    const {
        data: contentData, // हमें वास्तव में contentData की आवश्यकता नहीं है, लेकिन क्वेरी को चलाने के लिए इसकी आवश्यकता है।
        isLoading: isContentListLoading,
        isError: isContentListError,
        error: contentListError,
        isSuccess: isContentListSuccess
    } = useGetAllContentAdminQuery(queryArgs);

    // RTK Query कैश से विशिष्ट कंटेंट आइटम चुनें
    const contentItem = useSelector(state =>
        selectContentByIdForAdmin(state, queryArgs, contentId)
    );

    if (isContentListLoading) {
        return <div className="text-center my-5"><Spinner animation="border" role="status" /><p className="mt-2">Loading content...</p></div>;
    }

    if (isContentListError) {
        return <Alert variant="danger" className="text-center my-5">{contentListError?.data?.message || 'Error loading content list.'}</Alert>;
    }

    if (isContentListSuccess && !contentItem) {
        return <p className="errmsg text-center my-5">Content with ID "{contentId}" not found or not on the current page of results.</p>;
    }

    if (!isManager && !isAdmin) {
        return <Alert variant="danger" className="text-center my-5">You do not have permission to edit content.</Alert>;
    }

    const content = (
        <Container className="my-4">
            <EditContentForm contentItem={contentItem} />
        </Container>
    );

    return content;
};

export default EditContent;